module.exports = __webpack_public_path__ + "img/avatar1.4c5b4c60.png";